import { DesignThemeConfiguration } from '@celum/portals/domain';
import { QuillEditorConfiguration } from '@celum/quill-editor';

import { createColorPalettes } from './color-palette.util';
import { defaultTypographyConfiguration } from '../model/default-typography.model';

export function createQuillEditorConfiguration(themeConfiguration: DesignThemeConfiguration): QuillEditorConfiguration {
  const typographyConfiguration = themeConfiguration ? themeConfiguration.typography.settings : defaultTypographyConfiguration.settings;
  return {
    typographySettings: typographyConfiguration.map(typography => ({
      key: typography.key,
      fontColorId: typography.fontColorId,
      formatting: typography.formatting,
      fontWeight: typography.fontWeight,
      longLabel: `PORTALS.QUILL.TYPOGRAPHIES.${typography.key.toUpperCase()}.LONG`,
      shortLabel: `PORTALS.QUILL.TYPOGRAPHIES.${typography.key.toUpperCase()}.SHORT`
    })),
    fontSizeEnabled: !themeConfiguration,
    formatOnlyByTags: !themeConfiguration,
    ...(themeConfiguration && { colorPalette: createColorPalettes(themeConfiguration.colorPalette) })
  };
}
